export const calculatorTemplate = `
<div class="calculator-wrap">
	<div class="calculator-onpage">
		<div class="calculator-inner">
			<div v-if="validationError" class="alert alert-danger calc-alert">
				{{ msg("CALC_VALIDATION_ERROR") }}
			</div>
			<h3 class="font_weight--600">{{ msg("CALC_NAME") }}</h3>
			<form role="form" @submit.prevent="submitCalculate">
				<div class="col-xs">
					<div class="form-group first_group">
						<div class="col-xs-12 calc-autocomplete">
							<input type="text" class="form-control"
								:placeholder="msg('CALC_CITY_FROM')"
								v-model="cityFrom"
								@input="debouncedCitySearch('from', cityFrom)"
								@focus="cityFromOpen = cityFromSuggestions.length > 0"
								required>
							<ul v-if="cityFromOpen && cityFromSuggestions.length" class="calc-autocomplete__list">
								<li v-for="(city, idx) in cityFromSuggestions" :key="'from-' + idx"
									@mousedown.prevent="selectCity('from', city)">{{ city }}</li>
							</ul>
						</div>
					</div>
					<div class="form-group first_group m-top---20">
						<div class="col-xs-12">
							<input type="checkbox" v-model="fromCheck" id="from_check2" class="form-checkbox__input form-checkbox__input--visible">
							<label for="from_check2" class="form-checkbox__label">
								<span class="form-checkbox__box"></span>
								{{ msg("CALC_FROM_CHECK2") }}
								<span class="tooltiper" :title="msg('CALC_FROM_CHECK_TOOLTIP')"></span>
							</label>
						</div>
					</div>
					<div class="form-group first_group">
						<div class="col-xs-12">
							<button type="button" @click="swapCities" class="swap-button" title="Поменять местами">
								<svg width="800px" height="800px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="m7.75 5.75-3-3-3 3m3 7.5v-10.5m9.5 7.5-3 3-3-3m3-7.5v10.5"/></svg>
							</button>
						</div>
					</div>
					<div class="form-group first_group">
						<div class="col-xs-12 calc-autocomplete">
							<input type="text" class="form-control"
								:placeholder="msg('CALC_CITY_TO')"
								v-model="cityTo"
								@input="debouncedCitySearch('to', cityTo)"
								@focus="debouncedCitySearch('to', cityTo)"
								required>
							<ul v-if="cityToOpen && cityToSuggestions.length" class="calc-autocomplete__list">
								<li v-for="(city, idx) in cityToSuggestions" :key="'to-' + idx"
									@mousedown.prevent="selectCity('to', city)">{{ city }}</li>
							</ul>
						</div>
					</div>
					<div class="form-group first_group m-top---20">
						<div class="col-xs-12">
							<input type="checkbox" v-model="toCheck" id="to_check2" class="form-checkbox__input form-checkbox__input--visible">
							<label for="to_check2" class="form-checkbox__label">
								<span class="form-checkbox__box"></span>
								{{ msg("CALC_TO_CHECK2") }}
								<span class="tooltiper" :title="msg('CALC_TO_CHECK_TOOLTIP')"></span>
							</label>
						</div>
					</div>
				</div>
				<div class="col-xs-12">
					<div class="form-group mb-20">
						<div class="btn-group" role="group">
							<button type="button" class="btn mode-tab-btn"
								:class="mode === 'common' ? 'btn-primary' : 'btn-default'"
								@click="switchMode('common')">{{ msg("CALC_MODE_COMMON") }}</button>
							<button type="button" class="btn mode-tab-btn"
								:class="mode === 'place' ? 'btn-primary' : 'btn-default'"
								@click="switchMode('place')">{{ msg("CALC_MODE_PLACE") }}</button>
						</div>
					</div>
					<div class="form-group" v-show="mode === 'place'">
						<div class="row">
							<div class="col-xs-9">
								<div class="gap mb-10" style="display:flex;flex-wrap:wrap;gap:10px;margin-bottom:10px;">
									<div v-for="tab in placeTabs" :key="tab.index"
										class="btn mb-10 mr-10"
										:class="tab.index === activePlaceIndex ? 'btn-primary' : 'btn-default'"
										style="display:inline-flex;align-items:center;gap:8px;cursor:pointer;"
										@click="switchTab(tab.index)">
										<span>{{ tab.label }}</span>
										<span v-if="places.length > 1" style="font-weight:bold;padding:0 4px;"
											@click.stop="deletePlace(tab.index)">&times;</span>
									</div>
								</div>
							</div>
							<div class="col-xs-3">
								<button type="button" @click="addPlace" class="btn btn-default mb-10 mr-10 btn-transparent-border has-ripple">
									{{ msg("CALC_PLACE_ADD") }}
								</button>
							</div>
						</div>
					</div>
				</div>
				<div class="col-xs-12" v-if="currentData">
					<div class="form-group">
						<div class="row">
							<div class="col-xs-4 input-group">
								<input type="text" class="form-control" :value="currentData.weight"
									@input="updateField('weight', $event.target.value)"
									:placeholder="msg('CALC_WEIGHT_PLACEHOLDER')">
								<div class="input-group-addon">кг</div>
							</div>
							<div class="col-xs-4 input-group">
								<input type="text" class="form-control" :class="{ disabled: volumeDisabled }"
									:disabled="volumeDisabled" :value="currentData.volume"
									@input="updateField('volume', $event.target.value)"
									:placeholder="msg('CALC_VOLUME_PLACEHOLDER')">
								<div class="input-group-addon">м³</div>
							</div>
							<div class="col-xs-4 input-group">
								<input type="text" class="form-control" :value="currentData.quantity"
									@input="updateField('quantity', $event.target.value)"
									@blur="onQuantityBlur"
									:placeholder="msg('CALC_PLACE')">
								<div class="input-group-addon">шт</div>
							</div>
						</div>
					</div>
					<div class="form-group">
						<div class="row">
							<div class="col-xs-4 input-group">
								<input type="text" class="form-control" :class="{ 'border-danger': dimsError }"
									:value="currentData.long" @input="updateField('long', $event.target.value)"
									:placeholder="msg('CALC_LONG_PLACEHOLDER')">
								<div class="input-group-addon">м</div>
							</div>
							<div class="col-xs-4 input-group">
								<input type="text" class="form-control" :class="{ 'border-danger': dimsError }"
									:value="currentData.width" @input="updateField('width', $event.target.value)"
									:placeholder="msg('CALC_WIDTH_PLACEHOLDER')">
								<div class="input-group-addon">м</div>
							</div>
							<div class="col-xs-4 input-group">
								<input type="text" class="form-control" :class="{ 'border-danger': dimsError }"
									:value="currentData.height" @input="updateField('height', $event.target.value)"
									:placeholder="msg('CALC_HEIGHT_PLACEHOLDER')">
								<div class="input-group-addon">м</div>
							</div>
						</div>
						<div v-if="dimsError" class="row text-danger">
							<div class="col-xs-12">{{ msg("CALC_DIMS_ERROR") }}</div>
						</div>
					</div>
					<div class="form-group">
						<div class="input-group">
							<input type="text" class="form-control" :value="currentData.declaredValue"
								@input="updateField('declaredValue', $event.target.value)"
								:placeholder="msg('CALC_CARGO_VALUE')">
							<div class="input-group-addon">руб</div>
						</div>
					</div>
					<div class="form-group">
						<div class="flexbox flexbox--direction-row flexbox--wrap-nowrap gap gap--20 overflow-x-auto">
							<div class="input-group">
								<div class="form-control">
									<input type="checkbox" :checked="currentData.crate" @change="onCheckboxChange('crate', $event)" :id="'crate-' + mode + '-' + activePlaceIndex" class="form-checkbox__input form-checkbox__input--visible">
									<label class="flex-colum form-checkbox__label offset_bottom" :for="'crate-' + mode + '-' + activePlaceIndex">
										<span class="form-checkbox__box"></span>
										<div>{{ msg("CALC_CRATE") }}</div>
										<span class="add_serv_price">{{ packagePreview.crate }}</span>
									</label>
								</div>
							</div>
							<div class="input-group">
								<div class="form-control">
									<input type="checkbox" :checked="currentData.pallet" @change="onCheckboxChange('pallet', $event)" :id="'pallet-' + mode + '-' + activePlaceIndex" class="form-checkbox__input form-checkbox__input--visible">
									<label class="flex-colum form-checkbox__label offset_bottom" :for="'pallet-' + mode + '-' + activePlaceIndex">
										<span class="form-checkbox__box"></span>
										{{ msg("CALC_PALLET") }}
										<div class="add_serv_price">{{ packagePreview.pallet }}</div>
									</label>
								</div>
							</div>
							<div class="input-group">
								<div class="form-control">
									<input type="checkbox" :checked="currentData.stretchFilm" @change="onCheckboxChange('stretchFilm', $event)" :id="'stretch-film-' + mode + '-' + activePlaceIndex" class="form-checkbox__input form-checkbox__input--visible">
									<label class="flex-colum form-checkbox__label offset_bottom" :for="'stretch-film-' + mode + '-' + activePlaceIndex">
										<span class="form-checkbox__box"></span>
										{{ msg("CALC_STRETCH_FILM") }}
										<div class="add_serv_price">{{ packagePreview.stretchFilm }}</div>
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-xs-12">
					<button type="submit" class="btn btn-danger btn-lg" :disabled="loading">
						{{ calculated ? msg("CALC_BTN_RECALC") : msg("CALC_BTN_RESULT") }}
					</button>
				</div>
			</form>
		</div>
		<div class="calculator-order">
			<div v-if="orderHtml" v-html="orderHtml"></div>
			<div v-else class="calculator-order-inner">
				<div class="calculator-order__title">{{ msg("CALC_ORDER_TITLE") }}</div>
				<div class="calculator-order__sum">0 руб.</div>
				<div class="calculator-order__route">{{ msg("CALC_ORDER_ROUTE") }}</div>
			</div>
			<div v-if="!orderHtml">
				<a href="/oformite-zayavku-onlayn/" target="_blank" class="btn btn-default btn-lg btn-op-order">{{ msg("CALC_ORDER_BTN") }}</a>
			</div>
		</div>
	</div>
</div>
`.trim();
